import type { IInjector, IInjectorModule } from '@paperbits/common/injection';

import { GoogleMapsBindingHandler } from './ko/bindingHandlers.googlemap';
import { MapRuntime } from './ko/runtime/map-runtime';
import { MapReplyOfficesRuntime } from './ko/runtime/map-reply-offices-runtime';
import { MapReplyOfficesHTMLElement } from './ko/runtime/map-reply-offices-selector-runtime'

export class MapRuntimeModule implements IInjectorModule {
    public register(injector: IInjector): void {
        injector.bind('mapRuntime', MapRuntime); // FIXME(injector)
        injector.bindToCollection('autostart', GoogleMapsBindingHandler); // FIXME(injector)
        customElements.define('map-reply-offices-runtime', MapReplyOfficesRuntime);
        customElements.define('map-reply-offices-selector-runtime', MapReplyOfficesHTMLElement);
    }
}
